import { createSlice } from "@reduxjs/toolkit";
import { sponsorsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const sponsorsSlice = createSlice({
  name: "sponsors",
  initialState: data,
  reducers: {
    sponsorsSlice(state) {
      state.isLoading = false;
    },
    sponsorsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    sponsorsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    sponsorsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const sponsorsHandler = () => async (dispatch: any) => {
  try {
    dispatch(sponsorsAction.sponsorsSlice());
    const response: any = await sponsorsAPI();
    dispatch(sponsorsAction.sponsorsSliceSuccess(response));
  } catch (e: any) {
    dispatch(sponsorsAction.sponsorsSliceFailure(e?.response?.data?.message));
    dispatch(sponsorsAction.sponsorsSliceReset());
  }
};
export default sponsorsSlice.reducer;
export const sponsorsAction = sponsorsSlice.actions;
